import { Lazy } from '@nx-data/utilities';
import { Entity } from './entity';
import { ManyOf, ReadOnlyManyOf } from './many-of';
import { OneOf } from './one-of';

export type InferKeyName<T, K extends keyof T> = T[K] extends OneOf<any> ? never : T[K] extends ManyOf<any> ? never : K;

type InferKeyType<T, K extends keyof T> = T[K] extends OneOf<any> ? never : T[K] extends ManyOf<any> ? never : T[K];

type PatchModelInternal<T extends Entity> = {
  [K in keyof T as InferKeyName<T, K>]: InferKeyType<T, K>;
};

export type MappedEntityModel<T extends Entity> = {
  [K in keyof T]: T[K] extends OneOf<infer R>
    ? Lazy<MappedEntityModel<R>>
    : T[K] extends ManyOf<infer S>
    ? Lazy<ReadOnlyManyOf<MappedEntityModel<S>>>
    : T[K];
};

export type CreateModel<T extends Entity> = Omit<PatchModelInternal<T>, 'internalGuid' | 'createTimestamp' | 'lastUpdateTimestamp'>;
export type PatchModel<T extends Entity> = Partial<Omit<CreateModel<T>, 'id'>>;
